// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"f2fd84bf","354":"48273fa7","838":"718e91c9"}[chunkId] + ".js";
};